module.exports = __webpack_public_path__ + "img/fbx.0e8ba27b.svg";